import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchSiteInspectionBooking } from "../../Thunks/SiteInspectionBookingThunks";
import { SiteInspectionBooking } from "../../Types/SiteInspectionBooking/SiteInspectionBookingTypes";

interface SiteInspectionBookingSliceState {
    loadingSiteInspectionBooking: boolean;
    siteInspectionBookings: SiteInspectionBooking[];
    errorSiteInspectionBooking: string | null;
}

const initialState: SiteInspectionBookingSliceState = {
    loadingSiteInspectionBooking: false,
    siteInspectionBookings: [],
    errorSiteInspectionBooking: '',
}

const siteInspectionBookingSlice = createSlice({
    name: 'siteInspectionBooking',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            // For Site inspection bookings
            .addCase(fetchSiteInspectionBooking.rejected, (state, action) => {
                state.loadingSiteInspectionBooking = false;
                state.errorSiteInspectionBooking = action.error.message!;
            })
            .addCase(fetchSiteInspectionBooking.pending, state => {
                state.loadingSiteInspectionBooking = true;
                state.errorSiteInspectionBooking = null;
            })
            .addCase(fetchSiteInspectionBooking.fulfilled, (state, action: PayloadAction<SiteInspectionBooking[]>) => {
                state.siteInspectionBookings = [];
                state.loadingSiteInspectionBooking = false;
                state.siteInspectionBookings = action.payload;
            })
    }
})

export default siteInspectionBookingSlice.reducer
